// Centralised content + image assets for Abayle Logistics and Trading.

export const COMPANY = {
  name: "Abayle Logistics and Trading",
  tagline: "Moving Somalia. Connecting the World.",
  serviceLine: "Logistics • Global Trade • Clearance • Car Sales • Car Rental",
  phones: ["+252 61 5555864"],
  email: "info@abayle.com",
  address: "AAIA Airport, Wadajir District, Mogadishu, Somalia",
};

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_86a699e2-b0a9-4997-98ec-7b67faf7f3f7/artifacts/diisn0ae_Logo.jpeg",
  hero: "https://customer-assets.emergentagent.com/job_86a699e2-b0a9-4997-98ec-7b67faf7f3f7/artifacts/4btfzxr7_Hero%20Image.png",
  aboutPort: "https://customer-assets.emergentagent.com/job_86a699e2-b0a9-4997-98ec-7b67faf7f3f7/artifacts/9qts9ohy_A%20professional%20port%2C%20cargo%2C%20or%20transport%20coordination%20image.png",
  pickup: "https://customer-assets.emergentagent.com/job_86a699e2-b0a9-4997-98ec-7b67faf7f3f7/artifacts/qlxxer2b_A%20premium%20pickup%20or%204x4%20vehicle%20in%20a%20clean%2C%20professional%20environment.png",
  // Curated premium stock
  suvRental: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?auto=format&fit=crop&w=1600&q=80",
  logistics: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1600&q=80",
  globalTrade: "https://images.unsplash.com/photo-1494412651409-8963ce7935a7?auto=format&fit=crop&w=1600&q=80",
  clearance: "https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=1600&q=80",
  carSales: "https://customer-assets.emergentagent.com/job_86a699e2-b0a9-4997-98ec-7b67faf7f3f7/artifacts/qlxxer2b_A%20premium%20pickup%20or%204x4%20vehicle%20in%20a%20clean%2C%20professional%20environment.png",
  carRental: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?auto=format&fit=crop&w=1600&q=80",
  clients: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1600&q=80",
  aboutCorporate: "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?auto=format&fit=crop&w=1600&q=80",
  map: "https://images.unsplash.com/photo-1524661135-423995f22d0b?auto=format&fit=crop&w=1600&q=80",
};

export const SERVICES = [
  {
    key: "logistics",
    title: "Logistics",
    short:
      "We support cargo movement planning, coordination, and delivery across operating points, helping clients manage transport requirements with structure and reliability.",
    long:
      "Abayle supports logistics requirements through planning, coordination, scheduling, and movement support. Whether clients need goods moved between arrival points and destinations or require dependable handling across operating stages, Abayle works to ensure structure, visibility, and reliable execution. Logistics is a core backbone service within our integrated model.",
    icon: "Truck",
    image: IMAGES.logistics,
  },
  {
    key: "global-trade",
    title: "Global Trade",
    short:
      "We help simplify trade related processes by supporting documentation flow, coordination needs, and import and export activity.",
    long:
      "International trade can involve multiple parties, documents, timing pressures, and compliance expectations. Abayle helps reduce this complexity by supporting clients involved in import and export activity, trade coordination, and related commercial processes.",
    icon: "Globe2",
    image: IMAGES.globalTrade,
  },
  {
    key: "clearance",
    title: "Clearance",
    short:
      "We assist with clearance requirements by supporting document review, process follow up, and efficient movement through customs procedures.",
    long:
      "Abayle assists clients with clearance related needs by helping manage documentation review, process support, and movement through customs requirements. Efficient clearance helps reduce unnecessary delays and protects project timelines.",
    icon: "FileCheck2",
    image: IMAGES.clearance,
  },
  {
    key: "car-sales",
    title: "Car Sales",
    short:
      "We provide car sales solutions for businesses, projects, field teams, and clients seeking reliable operational vehicles.",
    long:
      "Abayle provides car sales solutions for clients seeking practical and reliable vehicles for commercial use, field operations, transport needs, and project mobility. Suitable for organizations, contractors, and businesses that require durable operational vehicles in Somalia.",
    icon: "Car",
    image: IMAGES.carSales,
  },
  {
    key: "car-rental",
    title: "Car Rental",
    short:
      "We offer car rental services for business travel, field operations, project mobility, and client transport needs.",
    long:
      "Abayle offers car rental solutions for organizations and clients that need flexible transport options for operations, business movement, visiting teams, field assignments, or day to day use — professional, dependable, and suitable for both routine and mission related mobility.",
    icon: "KeyRound",
    image: IMAGES.carRental,
  },
];

export const WHY_ABAYLE = [
  {
    title: "One Partner, Five Capabilities",
    text: "Abayle gives clients one reliable point of engagement across five connected service lines.",
    icon: "Layers",
  },
  {
    title: "Strong Local Knowledge",
    text: "The company understands Somali operating realities, movement requirements, and business conditions.",
    icon: "MapPin",
  },
  {
    title: "Professional Service",
    text: "Abayle is positioned to serve clients who expect responsive communication and accountable support.",
    icon: "ShieldCheck",
  },
  {
    title: "Flexible Engagement",
    text: "Clients can work with Abayle for one time assignments or ongoing operational needs.",
    icon: "Handshake",
  },
  {
    title: "Client Confidence",
    text: "The company is built around reliability, responsiveness, and practical service delivery.",
    icon: "Award",
  },
];

export const CLIENTS = [
  {
    title: "UN Agencies and International Organisations",
    text: "Support for operational movement, transport, and service coordination.",
    icon: "Globe",
  },
  {
    title: "International NGOs and Development Partners",
    text: "Reliable assistance for field programmes, mobility, and logistics related requirements.",
    icon: "HeartHandshake",
  },
  {
    title: "Importers and Exporters",
    text: "Support across trade processes, logistics, and clearance needs.",
    icon: "Ship",
  },
  {
    title: "Commercial Businesses",
    text: "Flexible services for movement, vehicles, and business continuity.",
    icon: "Building2",
  },
  {
    title: "Infrastructure and Project Based Clients",
    text: "Mobility and support services for construction, implementation, and operational delivery.",
    icon: "HardHat",
  },
  {
    title: "Diplomatic and Official Missions",
    text: "Professional transport and service support for official movement.",
    icon: "Landmark",
  },
];

export const CORE_VALUES = [
  {
    title: "Reliability",
    text: "We deliver on commitments and support clients with dependable service.",
    icon: "ShieldCheck",
  },
  {
    title: "Local Expertise",
    text: "We understand the Somali environment, business realities, and operating conditions.",
    icon: "Compass",
  },
  {
    title: "Responsiveness",
    text: "We believe clients should receive fast, clear, and practical communication.",
    icon: "Zap",
  },
];

export const NAV_ITEMS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/services", label: "Services" },
  { to: "/car-solutions", label: "Car Solutions" },
  { to: "/why-abayle", label: "Why Abayle" },
  { to: "/clients", label: "Clients" },
  { to: "/contact", label: "Contact Us" },
];
